import type { ConceptDef } from '../types';

export const receptiveColors: ConceptDef = {
  kind: 'tileMatch',
  id: 'receptive-colors',
  label: 'Receptive Colors',
  category: 'Receptive',
  description: 'Hear a color name and tap the matching color.',
  config: {
    promptMode: 'AUDIO',
    tileCount: 4,
    items: [
      { say: 'red', answer: '🟥 red' },
      { say: 'blue', answer: '🟦 blue' },
      { say: 'green', answer: '🟩 green' },
      { say: 'yellow', answer: '🟨 yellow' },
      { say: 'purple', answer: '🟪 purple' },
      { say: 'orange', answer: '🟧 orange' },
    ],
  },
};
